import { memo } from 'react';

import { Heading, Text } from '@/components/core';
import { TriggerHeader } from '@/components/flow';
import { APILogo } from '@/components/logos';

export type APITriggerNodeContentProps = {
  agentId: string;
  actionId: string;
};

const IAPITriggerNodeContent = ({ agentId, actionId }: APITriggerNodeContentProps) => {
  return (
    <>
      <div className="flex items-center gap-2 border-b border-gray-200 pb-2">
        <TriggerHeader agentId={agentId} actionId={actionId}>
          <APILogo size="lg" />
          <Heading size="lg">Import from API</Heading>
        </TriggerHeader>
      </div>

      <div className="flex flex-col gap-2 pt-2">
        <Text>When a document is submitted through the API.</Text>
      </div>
    </>
  );
};

export const APITriggerNodeContent = memo(IAPITriggerNodeContent) as typeof IAPITriggerNodeContent;
